/* ========================================================================
 * FD:          FD
 * Child:       SORTABLE
 * Version:     1.0
 * ======================================================================== 
 * Description:
 * sortable
 * ======================================================================== 
 * 2/13/2016: creation
 * 5/2/2016: new parent handler
*/

FD.CONTROL = (function ($, me) {
    'use strict';

    var child = me.CONTROL || {};


    /* ========================================================================
     *  private vars
     * ========================================================================
    */

    //  element
    var ELEM = '[data-fd="sortable"]';
    var PARENT = '[data-parent="true"]';

    //  defaults
    var defaults = {
        handle: '.handle',
        axis: 'y',
        cursor: "ns-resize",
                //  ns-resize
                //  move
        tag: 30,
        value: '',
        useparent: true,
        parentid: -1,
        callbackprefix: 1,
    };


    /* ========================================================================
     *  private methods
     * ========================================================================
    */




    //  get sortable
    function getSortable(container) {
        var list = '';

        //  set list
        if (container !== null) {
            if (typeof container === 'string') container = $(container);
            list = container.find(ELEM);
        } else {
            list = $(ELEM);
        }


        $('.handle').css({ cursor: 'pointer' });


        //  bail
        if (list.length === 0) return;


        //  element
        list.each(function (i, e) {
            var elem = $(e);

            //  set options
            var options = $.extend({}, defaults, elem.data());

            //  set elem data
            me.setControlItemOptions(elem, options);

            //  set data
            elem.data(options);


            var $sortable = elem.sortable({
                axis: options.axis,
                cursor: options.cursor,
                handle: options.handle,
                placeholder: "ui-state-highlight-table",
                forcePlaceholderSize: true,
                stop: afterStop,
                start: onStart,
                sort: checkSlimScroll,
                items: ".sorting-initialize"
            });

            $sortable.children("li,tr").one("mouseenter", function () {
                $(this).addClass("sorting-initialize");
                $sortable.sortable('refresh');
            });
        });
    }


    function onStart(event, ui) {
        var elem = ui.item;
        var parent = elem.parents('table');
        
        if (parent.length > 0) {
            me.setRowStaticHighlightFromTarget(elem);
        }
        var scrollContainer = ui.item.closest('[data-fd="scroll"]');
        if (scrollContainer) {
            scrollContainer.slimScroll({
                alwaysVisible: true,
                disableFadeOut: true,
            });
        }
    }

    function afterStop(event, ui) {
        var item = ui.item;
        var e = $(ui.item).closest('ul');
        var children;
        var result = '';

        if (e.length == 0 || item[0].localName == 'tr') {
            e = $(ui.item).closest('tbody');
            children = e.children('tr');
        } else {
            children = e.children('li');
        }
        if (e.length == 0 && item[0].localName == 'div') {
            e = $(ui.item).closest('[data-fd=sortable]');
            children = e.children('[data-parentid]');
        }

        children.each(function(i) {
            var data = $(this).data();
            if (data != 'undefined') {
                if (data.parentid && data.parentid != 'undefined') {
                    var id = data.parentid;
                    result += id + '|';
                }
            }
        });

        e.data().value = result;

        //  callback
        var data = e.data();
        me.setCallBackFromData(e, { e: data.element, value: data.value, tag: data.tag, parentid: data.parentid });

        var scrollContainer = ui.item.closest('[data-fd="scroll"]');
        if (scrollContainer) {
            scrollContainer.slimScroll({
                alwaysVisible: false,
                disableFadeOut: false,
                railVisible: false
            });
        }
    }


    function checkSlimScroll(event, ui) {
        var scrollContainer = ui.helper.closest('[data-fd="scroll"]');
        if (scrollContainer) {
            if (ui.position.top < 50) {
                scrollContainer.slimScroll({ scrollByY: '-25px', alwaysVisible: true, disableFadeOut: true });
            } else if (ui.position.top > scrollContainer.height() - 50) {
                scrollContainer.slimScroll({ scrollByY: '25px', alwaysVisible: true, disableFadeOut: true });
            }
        }
    }








    /* ========================================================================
     *  public methods
     * ========================================================================
    */




    //  set sortable
    child.setSortable = function (container) {
        getSortable(container);
    };


    /* ========================================================================
     *  return
     * ========================================================================
    */
    return child;
}(jQuery, FD));